import React from "react";
import styles from "./Button.module.css";
import { CircularProgress } from "../../loaders/CircularProgress/CircularProgress";

// Generic button component w/ integrated loading logic
export interface ButtonProps extends Omit<React.HTMLProps<HTMLButtonElement>, "ref"> {
  loading?: boolean;
  disabledOnLoading?: boolean;
  progress?: number; // 0-100, only used if loading is true
  children: React.ReactNode;
}
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ loading, disabledOnLoading = true, progress, children, ...rest }, ref) => {
    return (
      <button
        type={"button" as any}
        {...rest}
        ref={ref}
        disabled={(loading && disabledOnLoading) || rest.disabled}
        className={`${rest.className} ${loading ? `${styles.btnLoading} loading` : ""}`}
      >
        {loading && progress !== undefined ? (
          <CircularProgress progress={progress} width={16} style={{ marginRight: 8 }} />
        ) : (
          loading && <span className="spinner" aria-hidden="true" />
        )}{" "}
        {children}
      </button>
    );
  }
);
